
import { Bed, Bath, Home, Calendar } from "lucide-react";

interface PropertyKeyStatsProps {
  bedrooms: number;
  bathrooms: number;
  squareFeet: number;
  yearBuilt: number | null;
}

export const PropertyKeyStats = ({
  bedrooms,
  bathrooms,
  squareFeet,
  yearBuilt
}: PropertyKeyStatsProps) => {
  return (
    <div className="flex flex-wrap justify-between items-center bg-card rounded-lg p-4">
      <div className="flex items-center">
        <Bed className="h-5 w-5 mr-2 text-godyspo-gold" />
        <div>
          <p className="font-medium">{bedrooms}</p>
          <p className="text-xs text-muted-foreground">Beds</p>
        </div>
      </div>
      <div className="flex items-center">
        <Bath className="h-5 w-5 mr-2 text-godyspo-gold" />
        <div>
          <p className="font-medium">{bathrooms}</p>
          <p className="text-xs text-muted-foreground">Baths</p>
        </div>
      </div>
      <div className="flex items-center">
        <Home className="h-5 w-5 mr-2 text-godyspo-gold" />
        <div>
          <p className="font-medium">{squareFeet.toLocaleString()}</p>
          <p className="text-xs text-muted-foreground">Sq Ft</p>
        </div>
      </div>
      <div className="flex items-center">
        <Calendar className="h-5 w-5 mr-2 text-godyspo-gold" />
        <div>
          <p className="font-medium">{yearBuilt || 'N/A'}</p>
          <p className="text-xs text-muted-foreground">Year Built</p>
        </div>
      </div>
    </div>
  );
};
